import { combineReducers } from '@reduxjs/toolkit';

import { UpgradeAccountReducer } from './upgradeAccount';
import { AddProSeatsReducer } from './addProSeats';
import { SubscriptionPricesReducer } from './subscriptionPrices';
import { PromotionalCodeReducer } from './promotionalCode';

export const UpgradeAccountCombinedReducer = combineReducers({
  data: UpgradeAccountReducer,
  addProSeatsInfo: AddProSeatsReducer,
  subscriptionPrices: SubscriptionPricesReducer,
  promotionalCode: PromotionalCodeReducer
});